// FIT TIP — Penny Clogs Size Finder
(function() {
  'use strict';

  var currentStep = 1;
  var totalSteps = 3;
  var answers = { cm: null, ancho: null, empeine: null };

  var TALLA_TABLE = [
    { min: 21.0, max: 22.4, mx_rec: 23, eu: 35 },
    { min: 22.5, max: 22.9, mx_rec: 23, eu: 35, border: true },
    { min: 23.0, max: 23.4, mx_rec: 24, eu: 36 },
    { min: 23.5, max: 23.9, mx_rec: 24, eu: 36, border: true },
    { min: 24.0, max: 24.4, mx_rec: 25, eu: 37 },
    { min: 24.5, max: 24.9, mx_rec: 25, eu: 37, border: true },
    { min: 25.0, max: 25.4, mx_rec: 26, eu: 38 },
    { min: 25.5, max: 25.9, mx_rec: 26, eu: 38, border: true },
    { min: 26.0, max: 26.4, mx_rec: 27, eu: 39 },
    { min: 26.5, max: 26.9, mx_rec: 27, eu: 39, border: true },
    { min: 27.0, max: 28.0, mx_rec: 28, eu: 40 },
  ];

  function getTalla(cm) {
    return TALLA_TABLE.find(function(t) { return cm >= t.min && cm <= t.max; }) || null;
  }

  function q(id) { return document.getElementById(id); }

  function init() {
    var cmInput  = q('bft-cm-input');
    var cmSlider = q('bft-cm-slider');
    if (!cmInput || !cmSlider) return;

    cmInput.addEventListener('input', function() {
      var v = parseFloat(cmInput.value);
      if (!isNaN(v) && v >= 21 && v <= 28) {
        cmSlider.value = v;
        answers.cm = v;
      } else {
        answers.cm = null;
      }
      updateNextBtn();
    });

    cmSlider.addEventListener('input', function() {
      var v = parseFloat(cmSlider.value);
      cmInput.value = v.toFixed(1);
      answers.cm = v;
      updateNextBtn();
    });
  }

  window.bftSelectOpt = function(field, val, el) {
    var container = el.parentElement;
    container.querySelectorAll('.opt').forEach(function(o) { o.classList.remove('selected'); });
    el.classList.add('selected');
    answers[field] = val;
    updateNextBtn();
  };

  function updateNextBtn() {
    var btn = q('bft-btn-next');
    if (!btn) return;
    if (currentStep === 1) btn.disabled = !answers.cm;
    else if (currentStep === 2) btn.disabled = !answers.ancho;
    else if (currentStep === 3) btn.disabled = !answers.empeine;
  }

  function updateProgress() {
    var pct = currentStep === 'result' ? 100 : (currentStep / totalSteps) * 100;
    var bar = q('bft-progress-bar');
    if (bar) bar.style.width = pct + '%';
  }

  function showStep(id) {
    document.querySelectorAll('.bdg-fit-widget .step').forEach(function(s) { s.classList.remove('active'); });
    var target = id === 'result' ? q('bft-step-result') : q('bft-step-' + id);
    if (target) target.classList.add('active');
  }

  window.bftGoNext = function() {
    if (currentStep < totalSteps) {
      currentStep++;
      showStep(currentStep);
      updateProgress();
      updateNextBtn();
      var back = q('bft-btn-back');
      if (back) back.style.display = currentStep > 1 ? 'inline-block' : 'none';
      if (currentStep === totalSteps) {
        var btn = q('bft-btn-next');
        if (btn) btn.textContent = 'Ver mi talla →';
      }
    } else {
      calculateResult();
    }
  };

  window.bftGoBack = function() {
    if (currentStep > 1) {
      currentStep--;
      showStep(currentStep);
      updateProgress();
      updateNextBtn();
      var btn = q('bft-btn-next');
      if (btn) btn.textContent = 'Continuar →';
      var back = q('bft-btn-back');
      if (back) back.style.display = currentStep > 1 ? 'inline-block' : 'none';
    }
  };

  window.bftRestart = function() {
    currentStep = 1;
    answers = { cm: null, ancho: null, empeine: null };
    var cmInput  = q('bft-cm-input');
    var cmSlider = q('bft-cm-slider');
    if (cmInput)  cmInput.value = '';
    if (cmSlider) cmSlider.value = 23.5;
    document.querySelectorAll('.bdg-fit-widget .opt').forEach(function(o) { o.classList.remove('selected'); });
    showStep(1);
    updateProgress();
    var back = q('bft-btn-back');
    var next = q('bft-btn-next');
    var footer = q('bft-footer');
    if (back)   back.style.display = 'none';
    if (next)   { next.textContent = 'Continuar →'; next.disabled = true; }
    if (footer) footer.style.display = 'flex';
  };

  function calculateResult() {
    var cm      = answers.cm;
    var ancho   = answers.ancho;
    var empeine = answers.empeine;
    var talla   = getTalla(cm);
    if (!talla) return;

    var mxRec      = talla.mx_rec;
    var eu         = talla.eu;
    var isBorder   = !!talla.border;
    var ajuste     = 'Exacto';
    var ajusteSub  = 'Fit ideal para tu medida';
    var confColor  = '#2D6A3F';

    if (isBorder && (ancho === 'ancho' || empeine === 'alto')) {
      mxRec     = Math.min(mxRec + 1, 28);
      eu        = Math.min(eu + 1, 42);
      ajuste    = 'Ajustado';
      ajusteSub = 'Por ancho/empeine';
      confColor = '#7A5C1E';
    } else if (isBorder) {
      ajuste    = 'Entre tallas';
      ajusteSub = 'Ver nota abajo';
      confColor = '#7A5C1E';
    }

    var anchoMap   = { estrecho: { pct: 30, lbl: 'Estrecho' }, normal: { pct: 55, lbl: 'Normal' }, ancho: { pct: 80, lbl: 'Ancho' } };
    var empeineMap = { bajo: { pct: 25, lbl: 'Bajo' }, normal: { pct: 55, lbl: 'Normal' }, alto: { pct: 80, lbl: 'Alto' } };
    var longPct    = Math.round(((cm - 21) / (28 - 21)) * 90 + 5);

    function set(id, val) { var el = q(id); if (el) el.textContent = val; }
    function setHTML(id, val) { var el = q(id); if (el) el.innerHTML = val; }
    function setStyle(id, prop, val) { var el = q(id); if (el) el.style[prop] = val; }

    set('bft-res-size', mxRec);
    set('bft-res-eu',   'EU ' + eu);
    set('bft-res-cm',   cm + ' cm de pie');
    set('bft-rc-mx',    mxRec);
    set('bft-rc-eu',    eu);
    setHTML('bft-rc-conf', '<span class="conf-dot" style="background:' + confColor + '"></span>' + ajuste);
    set('bft-rc-conf-sub', ajusteSub);

    var betweenNote = q('bft-between-note');
    if (betweenNote) {
      if (isBorder && ancho !== 'ancho' && empeine !== 'alto') {
        betweenNote.style.display = 'block';
        betweenNote.innerHTML = 'Tu pie está entre dos tallas. Si tu pie es normal o estrecho, quédate con la <strong>T' + mxRec + '</strong>. Si tienes pie ancho o empeine alto, considera la <strong>T' + Math.min(mxRec + 1, 28) + '</strong>.';
      } else {
        betweenNote.style.display = 'none';
      }
    }

    setStyle('bft-bar-long',  'width', longPct + '%');
    set('bft-lbl-long',  cm + ' cm');
    setStyle('bft-bar-ancho', 'width', anchoMap[ancho].pct + '%');
    set('bft-lbl-ancho', anchoMap[ancho].lbl);
    setStyle('bft-bar-emp',   'width', empeineMap[empeine].pct + '%');
    set('bft-lbl-emp',   empeineMap[empeine].lbl);

    currentStep = 'result';
    showStep('result');
    updateProgress();
    var footer = q('bft-footer');
    if (footer) footer.style.display = 'none';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
